import { Link } from 'lib/link';
import styled, { css } from 'styled-components';

const styledLinkInteractionStates = css`
  &:focus {
    text-decoration: none;
  }

  &:hover {
    color: ${({ theme }) => theme.color.primary[500].value};
    text-decoration: none;
  }
`;

const PageHeaderLink = styled(Link)`
  && {
    ${styledLinkInteractionStates}
    align-self: center;
    background-color: ${({ theme }) => theme.color.primary[50].value};
    border-radius: ${({ theme }) => theme.size.borderRadius.small.value};
    box-sizing: border-box;
    color: ${({ theme }) => theme.color.primary[500].value};
    cursor: pointer;
    padding: 0 ${({ theme }) => theme.size.spacing.medium.value} 0 0;
    position: relative;

    &:not(:visited) {
      ${styledLinkInteractionStates}
      color: ${({ theme }) => theme.color.primary[500].value};
    }

    &&:active {
      background-color: ${({ theme }) => theme.color.primary[100].value};
    }

    &:visited {
      color: ${({ theme }) => theme.color.primary[500].value};

      &:hover,
      &&:focus {
        background-color: ${({ theme }) => theme.color.primary[50].value};
        color: ${({ theme }) => theme.color.primary[500].value};
      }
    }
  }
`;

export { PageHeaderLink };
